<div id="getServedNetworkServers"
       class="table-header margin-top-30">
    <span>Served Network Servers</span>
    <div class="table-filter">
      <form class="form-inline ">
        <select id="table-network-search"
                [(ngModel)]="optionServedNetworkServerSearch"
                name="optionServedNetworkServerSearch"
                class="table-filter-search form-control"
                (change)='onOptionServedNetworkServerSearchChanged($event)'>
          <option selected="selected">Search Type</option>
          <option>NetID</option>
          <option>Name</option>
        </select>
        <input type="text"
               class="form-control"
               id="input-network-search"
               name="inputKeywordServedNetworkServerSearch"
               [(ngModel)]="inputKeywordServedNetworkServerSearch"
               aria-describedby="search"
               placeholder="Search"
               (keyup)="onKeywordSearch($event)">
        <i class="fa fa-search text-tooltip"
           aria-hidden="true"
           title-popup="Search" (click)="refreshServedNetworkServers()">
        </i>
      </form>
    </div>
    <div class="position-relative table-icon action">
      <i class="fa fa-list transition text-tooltip"
         aria-hidden="true"
         title-popup="List">
      </i>
      <div class="tooltip-actions width-140">
        <div class="arrow-up"></div>
        <ul>
          <li>
            <label col-id="0"
                   table-name="serving-join-servers-list"
                   class="checked">NetID
            </label>
          </li>
          <li>
            <label col-id="1"
                   table-name="serving-join-servers-list"
                   class="checked">Name
            </label>
          </li>
          <li>
            <label col-id="2"
                   table-name="serving-join-servers-list"
                   class="checked">Messages vNS
            </label>
          </li>
          <li>
            <label col-id="3"
                   table-name="serving-join-servers-list"
                   class="checked">Reject vNS
            </label>
          </li>
          <li>
            <label col-id="4"
                   table-name="serving-join-servers-list"
                   class="checked">Messages hNS
            </label>
          </li>
          <li>
            <label col-id="5"
                   table-name="serving-join-servers-list"
                   class="checked">Reject hNS
            </label>
          </li>
        </ul>
      </div>
    </div>
    <div class="table-icon refresh"
         (click)="refreshServedNetworkServers()">
      <i class="text-tooltip" [ngClass]="(servedNetworkServersRefreshing)?'fa fa-spinner fa-spin':'fa fa-refresh'"
         aria-hidden="true"
         title-popup="Refresh">
      </i>
    </div>
    <div *ngIf="isAdmin && canAddServedNetworkServers"
         class="table-icon plus">
      <i class="fa fa-plus transition text-tooltip"
         aria-hidden="true"
         title-popup="Add"
         (click)="createActivationAgreement(name,joinEUIs,virtId)"></i>
    </div>
  </div>
  <div class="table-panel">
    <table class="table-roaming-partners table table-striped table-responsive"
         id="served-network-servers-list">
      <thead>
      <tr>
        <th>NetID</th>
        <th>Name</th>
        <th class="text-tooltip" title-popup="Number of HomeNSAns that returned this NS as HomeNS">Processed HomeNSAns</th>
        <th class="text-tooltip" title-popup="Number of JoinReq sent by this NS">Processed JoinReq</th>
        <th class="text-tooltip" title-popup="Number of rejected JoinReq sent by this NS">Rejected JoinReq</th>
        <th *ngIf="isAdmin"></th>
      </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of listServedNetworkServers | paginate: configPagerServedNetworkServers">
          <td *ngIf="isAdmin && !item.isNSGroup" class="serverNetworkServers-netId-td"><a [routerLink]="['/network',item.nsId]">{{item.netIds | cidr}}</a></td>
          <td *ngIf="!isAdmin && !item.isNSGroup" class="serverNetworkServers-netId-td">{{item.netIds | cidr}}</td>
          <td *ngIf="isAdmin && item.isNSGroup" class="serverNetworkServers-netId-td"><a [routerLink]="['/network-group',item.nsId]">{{item.netIds | cidr}}</a></td>
          <td *ngIf="!isAdmin && item.isNSGroup" class="serverNetworkServers-netId-td">{{item.netIds | cidr}}</td>
          <td *ngIf="isAdmin && !item.isNSGroup"><a [routerLink]="['/network',item.nsId]">{{item.name}}</a></td>
          <td *ngIf="!isAdmin && !item.isNSGroup">{{item.name}}</td>
          <td *ngIf="isAdmin && item.isNSGroup"><a [routerLink]="['/network-group',item.nsId]">{{item.name}}</a></td>
          <td *ngIf="!isAdmin && item.isNSGroup">{{item.name}}</td>
          <td>{{item.vnsMessageCount}} {{item.hasError ? '(!)' : ''}}</td>
          <td>{{item.hnsMessageCount}} {{item.hasError ? '(!)' : ''}}</td>
          <td>{{item.hnsRejectCount}}</td>
          <td *ngIf="isAdmin">
            <ng-template #actionsPopup>
              <!-- SubscriberID field has been moved to NS for now. Thus, editing an activation agreement is not needed at this moment.-->

              <!--
              <p *ngIf="item.protocolVersion != '1.0'" class="popup-text"
                 (click)="editActivationAgreement(item.nsId, listInfo.virtId, item.name, listInfo.name, item.netIds, listInfo.joinEUIs)">
                Edit</p>-->

              <p class="popup-text" (click)="deleteModal.show()">Delete</p>
            </ng-template>
            <button class="view-detail-btn"
                    [popover]="actionsPopup"
                    placement="left"
                    triggers="click"
                    [outsideClick]="true"
                    container="body">...</button>
              <app-delete-modal #deleteModal
                            text="Served Network Server {{item.name}} will be deleted."
                            nsId="{{item.nsId}}"
                            jsId="{{virtId}}"
                            deleteType="activationAgreement"></app-delete-modal>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="noDataRow"
         *ngIf="!listServedNetworkServers || listServedNetworkServers.length === 0">There is no data available
    </div>
  </div>
  <app-pagination-custom [config]="configPagerServedNetworkServers"></app-pagination-custom>
